import { AppManager, assetDir } from '@common';
import * as PANOLENS from 'panolens';
import * as THREE from 'three';
import { textSprite, textSpriteTexture, textSpriteUpdateScale } from '../utils/textSprite';
import BaseInteractiveSpot from './BaseInteractiveSpot';

const labelScale = 0.38;
const labelStyle = {
  fontSize: 30,
  fillStyle: 'rgba(214, 0, 28, 1.0)',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  borderThickness: 1,
  strokeStyle: 'rgba(214, 0, 28, 1.0)',
};

export default class InfoVideoLabelSpot extends BaseInteractiveSpot {
  constructor(panorama, config) {
    super(panorama);
    this.videoConfig = config;

    new THREE.TextureLoader().load(`${assetDir}/images/buttons/video.png`, tex => {
      this.buttonMesh = this.createButton(tex);
      this.labelMesh = this.createLabel();
    });

    this.panorama.addEventListener('change-language', this.onChangeLanguage.bind(this));
  }


  createButton(baseTex) {
    baseTex.needsUpdate = true;
    const info = new PANOLENS.Infospot(300, baseTex, false, {
      onHoverStart: this.onHoverStart,
      onHoverEnd: this.onHoverEnd,
      onTouchStart: this.onTouchStart,
    });
    info.position.fromArray(this.videoConfig.position);
    info.addEventListener('click', this.onClick.bind(this));
    info.name = `videoButton-${this.label}`;
    this.panorama.add(info);
    return info;
  }


  createLabel() {
    const labelSprite = textSprite(this.label, labelScale, labelStyle);
    labelSprite.name = `videoLabel-${this.label}`;
    this.buttonMesh.addLabel(labelSprite);
    return labelSprite;
  }


  onClick(event) {
    const { action } = this.videoConfig;
    this.actionHandler(action);
  }


  onChangeLanguage() {
    if (!this.labelMesh || !this.labelMesh.material) return;
    this.labelMesh.material.map = textSpriteTexture(this.label, labelStyle);
    textSpriteUpdateScale(this.labelMesh, labelScale);
  }


  onHoverStart(info) {
    info.material.color.set('#bbb');
  }


  onHoverEnd(info) {
    info.material.color.set('#fff');
  }


  get label() {
    switch (AppManager.currentLanguage) {
      case 'ja':
        return 'コンテンツの詳細はこちら';
      case 'zh-Hant':
        return '詳細內容見此處';
      case 'zh-Hans':
        return '详细内容见此处';
      case 'en':
      default:
        return 'See the content details here';
    }
  }
}